import styled, { keyframes } from 'styled-components'

export const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`
export const SkeletonBase = styled.div`
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.1) 100%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
  border-radius: 16px;
`

export const Skeleton = styled(SkeletonBase)<{ width?: string; height?: string }>`
  width: ${({ width }) => width || '100px'};
  height: ${({ height }) => height || '20px'};
`
